// extracted by mini-css-extract-plugin
export default {"container":"BackModal_container__+jkvu","heading":"BackModal_heading__8jqxz","buttonContainer":"BackModal_buttonContainer__7fwr9","button":"BackModal_button__1ZCE5"};